// Surfaces AuthContext's serviceReachable=false state — i.e.
// the user is "optimistically authenticated" because their
// token-validation fetch hit a network error on reload, but the
// service may still be unreachable.
//
// Pass 2.4: paired with the three-state AuthContext refactor.
// When serviceReachable flips back to true (e.g. after a
// successful subsequent fetch), the banner won't render anymore.

import { AlertCircle } from "lucide-react";

import { useAuth } from "../state/AuthContext";

export function ServiceUnreachableBanner() {
  const { serviceReachable } = useAuth();
  if (serviceReachable) return null;
  return (
    <div
      role="alert"
      data-testid="service-unreachable-banner"
      className="px-4 py-2 bg-theme-error-bg border-b border-theme-error-border text-theme-error-text text-xs flex items-center justify-center gap-2"
    >
      <AlertCircle className="w-3.5 h-3.5" aria-hidden />
      <span className="font-mono">
        Service is unreachable — showing cached data.
      </span>
    </div>
  );
}
